const styles = {
  dashboardBackground: {
    width: '100%',
    minHeight: 'calc(100vh - 72px)',
    background: '#F9F9FF',
    height: '100%',
  },
  dashboardsWrapper: {
    maxWidth: '1600px',
    height: '100%',
  },
  campaignWrapper: {
    padding: '24px 40px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '@media screen and (max-width: 768px)': {
      padding: '24px 15px',
    },
  },
  loadingWrapper: {
    height: '60vh',
  },
  filtersWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 80,
    flexWrap: 'wrap',
    gap: 16,
    '@media screen and (max-width: 768px)': {
      marginBottom: 32,
    },
  },
  title: {
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: 'bold',
    marginBottom: 16,
  },
  newCampaignBtnWrapper: {
    '&:hover': {
      textDecoration: 'none',
    },
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  csvExportWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '16px',
    padding: '0 20px',
  },
  exportCsv: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px',
      fontWeight: '700',
    },
  },
  campaignChannelWrapper: {
    marginBottom: '44px',
    '@media screen and (max-width: 768px)': {
      marginBottom: '0px',
    },
  },
  campaignChannelTitle: {
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: 700,
    fontSize: '18px',
    marginLeft: '10px',
    marginBottom: '15px',
    '@media screen and (max-width: 768px)': {
      marginBottom: '12px',
    },
  },
  newCampaignBtn: {
    fontFamily: "'Proxima Nova', sans-serif",
    borderRadius: 12,
    backgroundColor: 'rgba(238, 67, 96, 1)',
    color: '#FFFFFF',
    textTransform: 'none',
    border: '1px solid rgba(238, 67, 96, 1)',
    minWidth: 230,
    padding: '10px 20px',
    height: 40,
    fontSize: 16,
    '&:hover': {
      backgroundColor: 'rgba(238, 67, 96, 1)',
    },
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  centered: {
    height: '100%',
    '@media screen and (max-width: 768px)': {
      marginTop: '250px',
    },
  },
  campaignDropdownBtn: {
    marginTop: '12px',
    '@media screen and (max-width: 768px)': {
      marginTop: '4px',
      width: '100%',
    },
  },
  newCampaignCTAOptionsWrapper: {
    width: '208px',
    position: 'absolute',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #2737541F',
    zIndex: '1000',
    marginTop: '4px',
    '& > p': {
      padding: '8px 10px',
      lineHeight: '18px',
      cursor: 'default',
      fontWeight: 400,
      color: '#0C172C',
      '&:hover': {
        '&:first-child': {
          borderRadius: '8px 8px 0 0',
        },
        background: '#E2E2FC',
        cursor: 'pointer',
        '&:last-child': {
          borderRadius: '0 0 8px 8px',
        },
      },
    },
    '@media screen and (max-width: 768px)': {
      zIndex: '2',
    },
  },
}

export default styles
